import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@eds-web/react';

import { StyledPrizeContainer } from './Prizes.style';
import { StepComponentProps } from './PrizeStep';
import { PROGRESS } from '../../constants/ProgressStates';

const Step4Active = () => {
    const { t } = useTranslation();

    return (
        <>
            <Text variant="paragraphMD">{t('epic.esport.step4.content')}</Text>

            <article>
                <Text variant="uiMDBold">{t('epic.esport.step4.verification.title')}</Text>
                <Text variant="paragraphMD" color="primary">
                    {t('epic.esport.step4.verification.list')}
                    <div style={{ paddingLeft: 32 }}>
                        <li>{t('epic.esport.step4.verification.item1')}</li>
                        <li>{t('epic.esport.step4.verification.item2')}</li>
                        <li>{t('epic.esport.step4.verification.item3')}</li>
                    </div>
                </Text>
            </article>

            <article>
                <Text variant="uiMDBold">{t('epic.esport.step4.minor.title.v2')}</Text>
                <Text variant="paragraphMD">{t('epic.esport.step4.minor.content.v2.item1')}</Text>
                <Text variant="paragraphMD">{t('epic.esport.step4.minor.content.v2.item2')}</Text>
            </article>
        </>
    );
};

export const Step4: React.FC<StepComponentProps> = ({
    status = PROGRESS.ACTIVE,
    offlinePayment = false
}) => {
    const { t } = useTranslation();

    const getTitle = () => {
        if (offlinePayment) {
            return t('epic.esport.step4.direct.title.v2');
        }
        return t('epic.esport.step4.title');
    };

    // Render content based on offline payment and status
    const renderContent = () => {
        if (offlinePayment) {
            if (status === PROGRESS.INCOMPLETE) {
                return (
                    <Text variant="paragraphMD">
                        {t('epic.esport.step4.direct.incomplete.content')}
                    </Text>
                );
            }
            if (status === PROGRESS.ACTIVE) {
                return (
                    <Text variant="paragraphMD">{t('epic.esport.step4.direct.content.v2')}</Text>
                );
            }
        }

        if (status === PROGRESS.INCOMPLETE) {
            return <Text variant="paragraphMD">{t('epic.esport.step4.incomplete.content')}</Text>;
        }

        return <Step4Active />;
    };

    return (
        <StyledPrizeContainer>
            <Text variant="headingMD">{getTitle()}</Text>
            {renderContent()}

            {/*<div>*/}
            {/*    <Button size="xl" variant="solid" onClick={onPrevious} disabled={!canGoPrevious}>*/}
            {/*        {t('epic.common.previous')}*/}
            {/*    </Button>*/}
            {/*</div>*/}
        </StyledPrizeContainer>
    );
};
